import { useState } from 'react';
import DropUpArrow from '../Icons/DropUpArrow';
import DropDownArrow from '../Icons/DropDownArrow';

interface IAccordionNewCarProps {
  title: string;
  children: React.ReactNode;
  dataIndex: number;
  dataTestId: string;
  typeID?: string;
  isOpenDefault?: boolean;
}

const AccordionNewCar = ({
  title,
  children,
  dataIndex,
  dataTestId,
  typeID,
  isOpenDefault = false,
}: IAccordionNewCarProps) => {
  const [isOpen, setIsOpen] = useState(
    (dataIndex === 0 && typeID !== 'accessories' ? true : false) || isOpenDefault
  );

  return (
    <button id="newCar" className="block w-full mb-2 last:mb-0 border-b border-reliableBlack10">
      <details
        className="py-[18px] lg:px-0"
        open={(dataIndex === 0 && typeID !== 'accessories') || isOpenDefault}
      >
        <summary
          className="-my-[18px] py-[18px] text-sm text-start font-medium text-reliableBlack cursor-pointer lg:text-base"
          data-testid={dataTestId}
          onClick={() => setIsOpen(!isOpen)}
        >
          <div className="w-full flex justify-between items-center px-4 lg:px-0 font-semibold text-[16px] text-[#231F20]">
            {title}
            <span className="ml-4">{isOpen ? <DropUpArrow /> : <DropDownArrow />}</span>
          </div>
        </summary>
        <div className="text-start text-sm font-normal text-reliableBlack leading-relaxed lg:text-base lg:leading-relaxed px-4 lg:px-0">
          {children}
        </div>
      </details>
    </button>
  );
};

export default AccordionNewCar;
